module.exports = __webpack_public_path__ + "static/media/Logo-CNM.c13dff2a.png";